/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneOperaRicercaOperaResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
    ) { }

    resolve(): Observable<any> {
        return forkJoin([
            this.anagraficaService.getComuni(),
            this.anagraficaService.getProvince(),
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            // this.anagraficaService.getProvenienza(),
            this.anagraficaService.getTipologiaIntervento(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getStatoOpera(),
            this.anagraficaService.getListaComunitaMontane(),
            this.anagraficaService.getListaConsorzi()
        ]).pipe(
            map(([
                responseAnagraficaComuni,
                responseAnagraficaProvince,
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaMateriale,
                // responseAnagraficaProvenienza,
                responseAnagraficaTipologiaIntervento,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaStatoOpera,
                responseListaComunitaMontane,
                responseListaConsorzi
            ]) => {
                return {
                    datalist: {
                        comuni: responseAnagraficaComuni,
                        province: responseAnagraficaProvince,
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        // provenienza: responseAnagraficaProvenienza,
                        tipologiaIntervento: responseAnagraficaTipologiaIntervento,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                        statoOpera: responseAnagraficaStatoOpera,
                        comunitaMontane: responseListaComunitaMontane,
                        consorzi: responseListaConsorzi
                    },
                };
            }),
        );
    }

}